import { render } from "./ModalConfiguracionHorarios.vue?vue&type=template&id=24e232d8"
import script from "./ModalConfiguracionHorarios.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracionHorarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__